import { ThemeProvider, useTheme } from '@mui/material';
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './App.css';
import './styles/styles.css';
import theme from './mui-theme';
import Router from './router';

function App() {
  const muiTheme = useTheme();
  return (
    <ThemeProvider theme={{ ...muiTheme, theme }}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID}>
        <Router />
      </GoogleOAuthProvider>
    </ThemeProvider>
  );
}

export default App;
